import React from 'react';
import { Typography, Box, AvatarGroup, Avatar, IconButton } from '@mui/material';
import { NavigateBefore } from '@mui/icons-material';
import { ParticipantView } from '@app/views';
import { useTeamChatController } from './TeamChatController';
import { useNavigate } from 'react-router-dom';
import { ChatConversation } from './ChatConversation';

export const TeamChatScreen: React.FC = () => {
  const { channel, groupName, headerHeight, allActiveCohortUsers, notifyCohort } = useTeamChatController();

  const navigate = useNavigate();

  return (
    <div id="team-chat" className="stream-chat">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: `calc(100svh - ${headerHeight}px)`,
          // Fallback for unsupported browsers:
          '@supports not (height: 100svh)': {
            height: `calc(100vh - ${headerHeight}px)`,
          },
          overflow: 'hidden',
          // Respect iOS home indicator
          paddingBottom: 'env(safe-area-inset-bottom)',
        }}
      >
        {/* Chat header */}
        <Box
          className="chat-header"
          sx={{
            display: 'flex',
            alignItems: 'center',
            px: 2,
            py: 1,
            borderBottom: '1px solid rgba(0,0,0,0.12)',
            backgroundColor: 'background.paper',
          }}
        >
          <IconButton
            edge="start"
            onClick={() => navigate(-1)}
            sx={{
              padding: 0,
              margin: 0,
              minWidth: 'auto',
              width: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#6d6d6d',
            }}
          >
            <NavigateBefore
              sx={{
                fontSize: '60px',
                stroke: '#fff',
                strokeWidth: 1,
              }}
            />
          </IconButton>

          <AvatarGroup
            max={4}
            spacing={15}
            sx={{
              flexDirection: 'row-reverse',
              justifyContent: 'start',

              // avatar sizing & border
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                border: '2px solid #fff',
                backgroundColor: '#fff', // Ensures avatars with transparency have a default background
              },

              '& .MuiAvatar-colorDefault': {
                zIndex: 1000, // ensures default avatars are on top
                backgroundColor: '#42797C',
              },
            }}
          >
            {allActiveCohortUsers?.map((participant: ParticipantView, index) => (
              <Avatar
                key={participant.id}
                alt={participant.name || participant.email}
                src={participant.avatarUrl || undefined}
                sx={{ zIndex: index + 1 }}
                slotProps={{ img: { referrerPolicy: 'no-referrer' } }}
              />
            ))}
          </AvatarGroup>

          <Box sx={{ flexGrow: 1, ml: 2, overflow: 'hidden', display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Typography variant="subtitle1" noWrap sx={{ fontWeight: 'bold', lineHeight: 1.2, mb: 0 }}>
              {groupName}
            </Typography>
            <Typography
              variant="caption"
              noWrap
              sx={{
                color: 'text.secondary',
                lineHeight: 1.2,
                mt: 0,
              }}
            >
              {/* Count of participants */}
              {allActiveCohortUsers ? `${allActiveCohortUsers.length} haters` : ''}
            </Typography>
          </Box>
        </Box>

        {/* Stream Chat */}
        {channel && <ChatConversation channel={channel} notify={notifyCohort} />}
      </Box>
    </div>
  );
};
